/** Build ExecutionScopeItemDetailView item shape from a scored metric row. */

function mapTestCaseSource(source) {
  if (source === "Defined" || source === "Custom") return "Custom";
  if (source === "Modified") return "Modified";
  return "Generated";
}

function caseRowFromTestCase(tc, testCasesById, perCaseRow) {
  const full =
    testCasesById?.get?.(tc.id) ||
    testCasesById?.get?.(String(tc.id)) ||
    tc;
  const row = {
    id: full.id,
    name: full.name || full.title || tc.name || "—",
    riskName: full.riskName || "—",
    source: mapTestCaseSource(full.source),
  };
  if (perCaseRow) {
    row.score = perCaseRow.score;
    row.passed = perCaseRow.passed;
    if (perCaseRow.reason != null) row.reason = perCaseRow.reason;
  }
  return row;
}

function perCaseByTestCaseId(result) {
  const perCase = Array.isArray(result?.perCase) ? result.perCase : [];
  return new Map(perCase.map((r) => [String(r.testCaseId), r]));
}

export function resolveScorecardMetricDetailItem(result, metricItems, testCasesById) {
  if (!result) return null;

  if (result.testCaseName) {
    const perCase = Array.isArray(result.perCase) ? result.perCase : [];
    const primaryId = perCase[0]?.testCaseId ?? result.key;
    const tc =
      testCasesById?.get?.(primaryId) ||
      testCasesById?.get?.(String(primaryId)) ||
      {};
    return {
      name: result.testCaseName,
      families: result.families || [],
      threshold: result.threshold,
      direction: result.direction,
      unit: result.unit,
      cases: [
        caseRowFromTestCase(
          { ...tc, id: primaryId, name: result.testCaseName || tc.name },
          testCasesById,
          perCase[0] || { score: result.value, passed: result.passed }
        ),
      ],
    };
  }

  const perById = perCaseByTestCaseId(result);

  const registerItem = (metricItems || []).find((m) => String(m.id) === String(result.key));

  const base = registerItem
    ? { ...registerItem }
    : {
        name: result.metricName,
        families: result.families || [],
        threshold: result.threshold,
        direction: result.direction,
        unit: result.unit,
        cases: [],
      };

  if (registerItem?.cases?.length) {
    return {
      ...base,
      cases: registerItem.cases.map((tc) =>
        caseRowFromTestCase(tc, testCasesById, perById.get(String(tc.id)))
      ),
    };
  }

  const perCase = Array.isArray(result.perCase) ? result.perCase : [];
  if (!perCase.length) return base;

  const cases = perCase.map((row) => {
    const id = row.testCaseId;
    const tc =
      testCasesById?.get?.(id) ||
      testCasesById?.get?.(String(id)) ||
      {};
    return caseRowFromTestCase({ ...tc, id }, testCasesById, row);
  });

  return { ...base, cases };
}
